<template>
  <div>
    <div v-if="detail.en">
      <BoardDetail
          :detail="detail"
          :key="detail.board_id"
          @close-detail="detail.en = false"
      />
    </div>
    <div v-else>
      <v-card class="elevation-0">
        <v-card-title class="container">
          <h1 class="mx-auto">برد ها</h1>
        </v-card-title>
        <v-card-text>
          <v-data-table
              hide-default-footer
              :headers="headers"
              :items="boards"
              :loading="loadingBoards"
              loading-text="در حال برقراری ارتباط زنده..."
              no-data-text="بردی پیدا نشد!"
              class="elevation-0"
          >
            <template v-slot:item.control="{ item }">
              <v-btn
                  class="elevation-0 my-5 pa-5 rounded-lg"
                  color="red"
                  outlined
                  :disabled="wsConnecting"
                  @click="showDetail(item)"
              >
                <strong class="mx-2">کنترل</strong>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14.9 13.49L13.5 14.89C13.3 15.09 12.99 15.09 12.79 14.89L9.38 11.48C8.16 11.91 6.74 11.65 5.76 10.67C4.65 9.56 4.46 7.88 5.17 6.57L7.52 8.92L8.93 7.51L6.58 5.17C7.9 4.46 9.57 4.65 10.68 5.76C11.66 6.74 11.92 8.16 11.49 9.38L14.9 12.79C15.09 12.98 15.09 13.3 14.9 13.49Z"
                        fill="red"/>
                </svg>
              </v-btn>
            </template>
            <template v-slot:item.update="{ item }">
              <v-btn
                  class="elevation-0 my-5 pa-5 rounded-lg"
                  :disabled="wsConnecting"
                  @click="showUpdate(item)"
                  large
              >
                <strong class="mx-2">ویرایش</strong>
                <v-icon large color="primary">mdi-tune</v-icon>
              </v-btn>
            </template>
            <template v-slot:body.append v-if="wsError">
              <tr>
                <td colspan="5" class="text-center py-3">
                  <v-alert type="error" dense text>
                    <div class="d-flex align-center justify-center">
                      <span>اتصال به سرور قطع شد. در حال تلاش مجدد...</span>
                      <v-progress-circular indeterminate size="16" class="mr-2" />
                    </div>
                  </v-alert>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <BoardUpdate
          :update="update"
          @close="update.en = false"
          @board-updated="handleBoardUpdate"
      />
    </div>
  </div>
</template>

<script>
import BoardDetail from "./detail.vue";
import BoardUpdate from "./update.vue";
import axios from "axios";

export default {
  name: "boardsList",
  components: {
    BoardDetail,
    BoardUpdate
  },
  data: () => ({
    key: localStorage.getItem("key"),
    boards: [],
    detail: {
      board_id: '',
      en: false,
    },
    update: {
      en: false,
      board: {}
    },
    loadingBoards: true,
    refreshInterval: null,
    headers: [
      { text: "ردیف", align: "center", value: "id" },
      { text: "نام برد", align: "center", value: "name", sortable: false },
      { text: "کد برد", align: "center", value: "code", sortable: false },
      { text: "کنترل", align: "center", value: "control", sortable: false },
      { text: "ویرایش", align: "center", value: "update", sortable: false },
    ],
  }),
  mounted() {
    this.fetchBoards();
    this.refreshInterval = setInterval(this.fetchBoards, 5000);
  },
  beforeDestroy() {
    if (this.refreshInterval) clearInterval(this.refreshInterval);
  },
  methods: {
    async fetchBoards() {
      this.loadingBoards = true;
      try {
        const { data } = await axios.get(`${this.BACKEND_LINK}/api/devices-data/boards/`, {
          headers: { Authorization: `Token ${this.key}` },
          timeout: 5000
        });
        this.boards = data;
      } catch (e) {
        console.error('[Boards] fetch failed', e);
        this.$snotify.error("خطا در دریافت لیست بردها");
      } finally {
        this.loadingBoards = false;
      }
    },

    showDetail(board) {
      this.detail = {
        board_id: board.id,
        en: true
      };
    },

    showUpdate(board) {
      this.update = {
        board: { ...board }, // Create copy to avoid direct mutation
        en: true
      };
    },

    // Handle updates from BoardUpdate modal
    handleBoardUpdate(updatedBoard) {
      const index = this.boards.findIndex(b => b.id === updatedBoard.id);
      if (index !== -1) {
        this.$set(this.boards, index, updatedBoard);
      }
    },

    showError(message) {
      this.$snotify.error(message, { timeout: 5000 });
    }
  }
};
</script>

<style scoped>
:deep(.v-data-table__wrapper) {
  overflow-x: auto;
}
</style>
